/**
 * Helper para obter a URL base do DirectUpload.
 * Se DIRECT_UPLOAD_URL estiver configurada no ambiente, usa essa URL.
 * Caso contrário, usa a URL atual do frontend (window.location.origin).
 */
export const getDirectUploadBaseUrl = () => {
  const directUploadUrl = window.chatwootConfig?.directUploadUrl;
  
  if (directUploadUrl && directUploadUrl.trim() !== '') {
    // Remove trailing slash se houver
    return directUploadUrl.replace(/\/$/, '');
  }
  
  // Fallback para a URL atual
  return window.location.origin;
};

/**
 * Constrói a URL completa do DirectUpload para conversations.
 * @param {number} accountId - ID da conta
 * @param {number} conversationId - ID da conversa
 * @returns {string} URL completa do DirectUpload
 */
export const buildConversationDirectUploadUrl = (accountId, conversationId) => {
  const baseUrl = getDirectUploadBaseUrl();
  return `${baseUrl}/api/v1/accounts/${accountId}/conversations/${conversationId}/direct_uploads`;
};

/**
 * Constrói a URL completa do DirectUpload para contacts.
 * @param {number} accountId - ID da conta
 * @param {number} contactId - ID do contato
 * @returns {string} URL completa do DirectUpload
 */
export const buildContactDirectUploadUrl = (accountId, contactId) => {
  const baseUrl = getDirectUploadBaseUrl();
  return `${baseUrl}/api/v1/accounts/${accountId}/contacts/${contactId}/direct_uploads`;
};

/**
 * Constrói a URL completa do DirectUpload para widget.
 * @param {string} websiteToken - Token do website
 * @returns {string} URL completa do DirectUpload
 */
export const buildWidgetDirectUploadUrl = (websiteToken) => {
  const baseUrl = getDirectUploadBaseUrl();
  return `${baseUrl}/api/v1/widget/direct_uploads?website_token=${websiteToken}`;
};

/**
 * Constrói a URL do blob do ActiveStorage.
 * @param {string} signedId - ID assinado do blob
 * @param {string} filename - Nome do arquivo
 * @returns {string} URL do blob
 */
export const buildBlobUrl = (signedId, filename) => {
  const baseUrl = getDirectUploadBaseUrl();
  return `${baseUrl}/rails/active_storage/blobs/${signedId}/${filename}`;
};

/**
 * Constrói a URL completa do DirectUpload para account (genérico).
 * @param {number} accountId - ID da conta
 * @returns {string} URL completa do DirectUpload
 */
export const buildAccountDirectUploadUrl = (accountId) => {
  const baseUrl = getDirectUploadBaseUrl();
  return `${baseUrl}/api/v1/accounts/${accountId}/direct_uploads`;
};

